
import {takeWhile} from 'rxjs/operators';
/**
 * Created by Ramon Wenger on 21.06.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IS_APP } from '../app.constants';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import * as reducer from "../reducers";
import { RoutingHistoryService } from '../routing-history/routing-history.service';

@Component({
    selector: 'hc-simple-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
      <div class="bg-dark-blue simple-header">
        <button aria-label="Back"
            class="header__back inline-block icon-arrow-left unstyled-button simple-header__back"
            [ngClass]="{'simple-header__back--isHidden': !showBack}"
            (click)="goBack()"
            data-cy="backButton">
            </button>
        <div class="main-title">
          <a href="#" class="public-header-title" (click)="goToMain()"><img class="public-header-title__heading" src="assets/icons/helloclass-font-white.svg" alt="helloclass-logo" /></a>
        </div>
      </div>
    `,
})
export class SimpleHeaderComponent {

    @Input() showBack = false;
    private alive = true;
    private backUrl: string;

    constructor(private router:Router,
                private store: Store<AppState>,
                private routingHistory: RoutingHistoryService) {
                    store.select(reducer.getBackUrl).pipe(
                    takeWhile(() => this.alive))
                    .subscribe(url => this.backUrl = url);
                }

    goToMain() {
        if (!IS_APP) {
            this.router.navigate(['/']);
        }
    }

    goBack() {
        if (IS_APP) {
            this.router.navigate(['/index_app.html']);
        } else {
            if (this.backUrl === '') {
                this.router.navigate(['/klassenbuch']);
            } else {
                this.router.navigate([this.routingHistory.getPreviousRoute()]);
            }
        }
    }

    ngOnDestroy() {
        this.alive = false
    }

}
